"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaboratoryMice = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var CardRequirements_1 = require("../../CardRequirements");
var CardRenderDynamicVictoryPoints_1 = require("../../render/CardRenderDynamicVictoryPoints");
var ResourceType_1 = require("../../../ResourceType");
var LaboratoryMice = (function (_super) {
    __extends(LaboratoryMice, _super);
    function LaboratoryMice() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.LABORATORY_MICE,
            cost: 8,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.ANIMAL],
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(3); }),
            metadata: {
                cardNumber: 'L305',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 Animal to this card.', function (eb) {
                        eb.empty().startAction.animals(1);
                    }).br;
                    b.animals(1).br;
                    b.vpText('1 VP per 3 Animals on this card.');
                }),
                description: 'Add 1 Animal to this card.',
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 3),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    LaboratoryMice.prototype.play = function (player) {
        player.addResourceTo(this);
        return undefined;
    };
    LaboratoryMice.prototype.getVictoryPoints = function () {
        return Math.floor(this.resourceCount / 3);
    };
    LaboratoryMice.prototype.canAct = function () {
        return true;
    };
    LaboratoryMice.prototype.action = function (player) {
        player.addResourceTo(this);
        return undefined;
    };
    return LaboratoryMice;
}(Card_1.Card));
exports.LaboratoryMice = LaboratoryMice;
//# sourceMappingURL=LaboratoryMice.js.map